module.exports = __webpack_public_path__ + "img/QuickEntrance_dzp.c1f438fb.svg";